import { render, staticRenderFns } from "./CoapCommandDestinationDialog.vue?vue&type=template&id=8dd18bfc&"
import script from "./CoapCommandDestinationDialog.vue?vue&type=script&lang=ts&"
export * from "./CoapCommandDestinationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports